module.exports = __webpack_public_path__ + "fonts/proxima_nova_regular-webfont.538c6d4e.ttf";